import axios from "../../utils/axios";
import api from "../../utils/api";

export const getUserBookings =
    ({ page = 1, limit = 5, type = 'upcoming' } = {}) =>
        async (dispatch) => {
            dispatch({
                type: "START_LOADING",
                payload: { loading: true },
            });

            try {
                const response = await axios.get(
                    `${api.userBookings}?page=${page}&limit=${limit}&type=${type}`
                );

                const { data, meta } = response.data;

                return { data, meta };
            } catch (err) {
                throw err;
            } finally {
                dispatch({
                    type: "START_LOADING",
                    payload: { loading: false },
                });
            }
        };
